import React from 'react';
import { ChevronDownIcon } from '@mentimeter/ragnar-visuals';
import type { NormalizedTemplateCategoryT } from 'shared/cms/templateCategories/normalizeTemplateCategory';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Clickable } from '@mentimeter/ragnar-ui/clickable';
import { Text } from '@mentimeter/ragnar-ui/text';
import { Collapsable } from '@mentimeter/ragnar-ui/collapsable';
import NavigationContent from './NavigationContent';

interface Props {
  categories: NormalizedTemplateCategoryT[];
}

const MobileNavigation = ({ categories }: Props) => {
  const [showMenu, setShowMenu] = React.useState<boolean>(false);

  return (
    <Box as="nav" width="100vw" bg="bg">
      <Box
        width="100%"
        py="space2"
        borderBottomWidth="1px"
        borderStyle="solid"
        borderColor="borderWeak"
        alignItems="center"
      >
        <Clickable
          aria-label="Menu"
          onClick={() => setShowMenu(!showMenu)}
          aria-expanded={showMenu}
          flexDirection="row"
          alignItems="center"
          extend={() => ({
            '@media (hover: hover)': {
              ':hover': {
                opacity: 1,
              },
            },
            ':active': {
              opacity: 1,
            },
          })}
        >
          <Text fontWeight="semiBold" color={showMenu ? 'primary' : 'text'}>
            Categories
          </Text>
          <Box
            ml="space2"
            extend={({ theme }) => ({
              transition: `transform ${theme.durations[1]}s ease`,
              transform: showMenu ? 'rotate(180deg)' : 'rotate(0)',
            })}
          >
            <ChevronDownIcon color={showMenu ? 'primary' : 'text'} size={2} />
          </Box>
        </Clickable>
      </Box>
      <Collapsable show={showMenu} width="100%">
        <Box width="100%" borderStyle="solid" borderColor="borderWeak">
          <NavigationContent
            categories={categories}
            onItemClick={() => {
              setShowMenu(false);
            }}
            aria-expanded={showMenu}
          />
        </Box>
      </Collapsable>
    </Box>
  );
};

export default MobileNavigation;
